






































































































































import { Component, Watch } from 'vue-property-decorator';

import { ComponenteBase } from '@/views/base/ComponenteBase';
import { LoadingService } from '@/services/loadingService';
import { Funcionalidades } from '@/config/funcionalidades';
const { AgGridVue } = require('ag-grid-vue');
import {
  GridOptions,
  GridApi,
  GridReadyEvent,
  ICellRendererParams,
  ColDef,
  ColumnApi,
  CellClickedEvent,
} from 'ag-grid-community';

import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import {
  PermisoAccion,
  codigoAccionesMenuItem as consultaInstalaciones,
} from '@/views/base/VariablesPermisos';
import store from '@/store';
import { actionsEvent } from '@/setup';
import MenuItem from '@/components/MenuItem.vue';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import moment from 'moment';

import { fetchConsultaInstalaciones } from './fetchConsultaInstalaciones';
import { getUserId } from '../MantenedorLocalidad/helpers/getUserId';
import { today } from './helpers/getDay';
import PopUpGeneratedReports from './PopUpGeneratedReoports.vue';
import {
  ParamsApi,
  GetFilters,
} from '@/pantallas/Conecta/ConsultaInstalaciones/models/ConsultaInstalacionesBaseModels';

@Component({
  components: {
    GridComponent: AgGridVue,
    FormFieldsContainer,
    DatePicker,
    PopUpGeneratedReports,
  },
})
export default class ConsultaInstalacionesBase extends ComponenteBase {
  readonly funcionalidad: Funcionalidades =
    Funcionalidades.ConsultaInstalaciones;
  readonly accionesTotales: PermisoAccion[] = [];
  readonly loadingService = new LoadingService();
  readonly codigoAccionesMenuItem: number[] = Object.values(
    consultaInstalaciones
  );

  columnApi: any = null;
  gridOptions: GridOptions = null;
  gridEvent: any = null;
  gridApi: GridApi = null;
  serverSide: any = null;
  columnDefs: ColDef[] = [];

  acitvateChange: boolean = false;
  showPopUpReport: boolean = false;

  startDateStr: string = '';
  endDateStr: string = '';
  msgReport: string = '';
  today: string = today();

  filter: GetFilters = {};
  objectParam: ParamsApi = {
    start_date: '',
    end_date: '',
    altasernumero: '',
    coorid: '',
    tipoeqid: '',
    serienumero: '',
    clienterut: '',
    otro_cliente_preparacion: false,
  };

  constructor() {
    super();
    this.columnDefs = this.colsGrid();

    this.gridOptions = {
      columnDefs: this.columnDefs,
      pagination: true,
      paginationPageSize: 50,
      cacheBlockSize: 50,
      overlayNoRowsTemplate: 'No hay filas para mostrar',

      rowModelType: 'serverSide',
      serverSideDatasource: this.serverSide,
      onGridReady: this.handleMainGridReady,
    };
  }

  private colsGrid(): ColDef[] {
    const colsId = [
      'Fecha Instalación',
      'Coordinador',
      'Técnico',
      'Orden de Servicio de Instalación',
      'Tipo de Equipo',
      'Serie Número',
      'SIM Número',
      'Cliente Instalación',
      'Flota',
      'Patente',
      'Requerimiento Preparación',
      'Cliente Preparación',
      'Fecha Preparación',
      'EPC',
      'Modalidad',
    ];
    let obj: ColDef = {};
    const cols: ColDef[] = [];

    for (const col of colsId) {
      obj = {
        headerName: col,
        field: col,
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 220,
        minWidth: 100,
      };
      cols.push(obj);
    }
    return cols;
  }

  async handleMainGridReady(event: GridReadyEvent): Promise<void> {
    this.filter = await this.getFilters();
    this.getDates(this.filter);
    this.gridApi = event.api;
    this.columnApi = event.columnApi;
    this.gridEvent = event;
    const self: this = this;

    this.serverSide = {
      async getRows(params: any): Promise<void> {
        params.request.paginationSize = self.gridOptions.cacheBlockSize;
        self.loadingService.showLoading();
        self.objectParam.start_date = self.startDateStr;
        self.objectParam.end_date = self.endDateStr;

        const paramsApi: any = {};
        for (const key in self.objectParam) {
          if (
            self.objectParam.hasOwnProperty(key) &&
            self.objectParam[key as keyof ParamsApi]
          ) {
            paramsApi[key] = self.objectParam[key as keyof ParamsApi];
          }
        }
        const objectApi = Object.assign({}, paramsApi, params.request);
        await fetchConsultaInstalaciones(
          { ...objectApi },
          'ConectaConsultaInstalaciones/get_all'
        )
          .then(response => {
            const {
              CODIGO_RESPUESTA,
              MENSAJE_RESPUESTA,
              LISTA,
            } = response.data;

            if (CODIGO_RESPUESTA != '1') {
              self.$snotify.error(MENSAJE_RESPUESTA, { timeout: 3500 });
              params.successCallback([{}], 0);
              self.gridApi.showNoRowsOverlay();
              return;
            }
            if (MENSAJE_RESPUESTA === 'SIN DATA') {
              self.$snotify.error(MENSAJE_RESPUESTA, { timeout: 3500 });
              params.successCallback([{}], 0);
              self.gridApi.showNoRowsOverlay();
              return;
            }
            params.successCallback(LISTA, LISTA[0].total_registros);
          })
          .catch((error: Error) => {
            console.error(error.message);
            self.$snotify.error(
              'Ocurrió un error inesperado, por favor reintente un poco más tarde.',
              {
                timeout: 3500,
              }
            );
            throw error;
          })
          .finally(() => {
            self.loadingService.hideLoading();
          });
      },
    };
    this.reloadGrid();
  }

  async reloadGrid(clear: boolean = false): Promise<void> {
    if (clear) this.clear();
    setTimeout(() => {
      this.gridApi.setServerSideDatasource(this.serverSide);
      this.gridApi.setDomLayout('autoHeight');
    }, 0);
  }

  @Watch('filter.start_date')
  startDateChange() {
    this.startDateStr = this.filter.start_date
      .toDate()
      .toISOString()
      .slice(0, 10);
    this.handleStartDate();
  }

  @Watch('filter.end_date')
  endDateChange() {
    this.endDateStr = this.filter.end_date
      .toDate()
      .toISOString()
      .slice(0, 10);
    this.handleEndDate();
  }

  handleSearchFilter(): void {
    const entries = Object.entries(this.objectParam);
    const hasValue = entries.some(
      ([key, value]: [string, ParamsApi]) =>
        key !== 'start_date' &&
        key !== 'end_date' &&
        key !== 'serienumero' &&
        value
    );
    if (hasValue) {
      this.acitvateChange = true;
      this.handleFilters();
      return;
    }
    if (this.objectParam) {
      this.reloadGrid();
    }
  }

  handleClearFilter(): void {
    if (this.acitvateChange || this.objectParam) {
      this.reloadGrid(true);
      return;
    }
    this.clear();
  }

  handleFilters(): void {
    if (this.objectParam.serienumero) {
      this.acitvateChange = false;
      console.log(
        'entro a la condicion this.objectParam.serienumero ',
        this.objectParam.serienumero
      );
    }
    console.log('objectParam: ', this.objectParam);
    if (this.acitvateChange) {
      this.reloadGrid();
    }
  }

  handleCloseReport(): void {
    this.showPopUpReport = false;
    this.msgReport = '';
  }

  clear(): void {
    this.acitvateChange = false;
    this.objectParam = Object.fromEntries(
      Object.keys(this.objectParam).map(key => [key, ''])
    );
    this.filter.start_date = moment().subtract(1, 'months');
    this.filter.end_date = moment();
  }

  getDates(filter: GetFilters): void {
    this.startDateStr = filter.start_date
      .toDate()
      .toISOString()
      .slice(0, 10);
    this.endDateStr = filter.end_date
      .toDate()
      .toISOString()
      .slice(0, 10);
  }

  handleStartDate(): void {
    if (this.startDateStr > this.endDateStr) {
      this.filter.end_date = this.filter.start_date;
    }
    this.handleFilters();
  }

  handleEndDate(): void {
    if (this.endDateStr < this.startDateStr) {
      this.filter.start_date = this.filter.end_date;
    }
    this.handleFilters();
  }

  async getFilters(): Promise<GetFilters> {
    const self: this = this;
    self.loadingService.showLoading();

    return await fetchConsultaInstalaciones(
      {},
      'ConectaConsultaInstalaciones/get_filters'
    )
      .then(response => {
        const { CODIGO_RESPUESTA, MENSAJE_RESPUESTA, LISTA } = response.data;

        if (CODIGO_RESPUESTA != '1') {
          self.$snotify.error(MENSAJE_RESPUESTA, { timeout: 3500 });
          return;
        }
        if (MENSAJE_RESPUESTA === 'SIN DATA') {
          self.$snotify.error(MENSAJE_RESPUESTA, { timeout: 3500 });
          return;
        }
        LISTA.start_date = moment().subtract(1, 'months');
        LISTA.end_date = moment();
        return LISTA;
      })
      .catch((error: Error) => {
        console.error(error.message);
        self.$snotify.error(
          'Ha ocurrido un error inesperado, por favor intente más tarde',
          { timeout: 3500 }
        );
        throw error;
      })
      .finally(() => {
        self.loadingService.hideLoading();
      });
  }

  async getCSV(): Promise<void> {
    const self: this = this;
    self.loadingService.showLoading();
    const paramsApi: any = {};

    for (const key in self.objectParam) {
      if (
        self.objectParam.hasOwnProperty(key) &&
        self.objectParam[key as keyof ParamsApi]
      ) {
        paramsApi[key] = self.objectParam[key as keyof ParamsApi];
      }
    }
    const userId = getUserId();
    const user = localStorage.getItem('clienteDefecto');

    return await fetchConsultaInstalaciones(
      {
        userId,
        user,
        ...paramsApi,
      },
      'ConectaConsultaInstalaciones/export_excel'
    )
      .then(response => {
        const { CODIGO_RESPUESTA, MENSAJE_RESPUESTA } = response.data;
        if (CODIGO_RESPUESTA != '1') {
          self.$snotify.error(MENSAJE_RESPUESTA, { timeout: 3500 });
          return;
        }
        self.msgReport = MENSAJE_RESPUESTA;
        self.showPopUpReport = true;
      })
      .catch((error: Error) => {
        console.error(error.message);
        self.$snotify.error(
          'Ha ocurrido un error inesperado, por favor intente más tarde',
          { timeout: 3500 }
        );
        throw error;
      })
      .finally(() => {
        self.loadingService.hideLoading();
      });
  }
}
